import axios from 'axios';
import api from '../../config/api';

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const quoteEndpoints = (mode, token) => {
  if (mode === 'admin') {
    return {
      calc: (b) => api.post('/admin/quotations/calc', b),
      create: (b) => api.post('/admin/quotations', b),
      list: () => api.get('/admin/quotations'),
    };
  }
  if (mode === 'cal') {
    const base = `${BACKEND}/api/admin-cal/${token}/quotations`;
    return {
      calc: (b) => axios.post(`${base}/calc`, b),
      create: (b) => axios.post(base, b),
      list: () => axios.get(base),
    };
  }
  return {
    calc: (b) => axios.post(`${BACKEND}/api/quotations/calc`, b),
    create: (b) => axios.post(`${BACKEND}/api/quotations`, b),
    list: null,
  };
};

export const emailQuote = (id, to) => axios.post(`${BACKEND}/api/quotations/${id}/email`, { to });

export const pdfUrl = (q) => `${BACKEND}${q.pdf_path}`;

export const inr = (n) => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;

export const fmtDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}-${m}-${y}`;
};

export const errMsg = (e, fallback = 'Something went wrong') => e?.response?.data?.detail || fallback;
